import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { toast } from "sonner";
import { ApiError } from "@/lib/api-generated/core/ApiError";
import { logger } from "./logger";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      // Handle 401 Unauthorized globally
      if (error instanceof ApiError && error.status === 401) {
        logger.warn("Global 401 detected, dispatching unauthorized event");
        window.dispatchEvent(new CustomEvent('unauthorized'));
        return;
      }

      const errorMessage = error instanceof Error ? error.message : "An error occurred";
      logger.error("Global Query Error:", error);
      toast.error("Error", { description: errorMessage });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      // Handle 401 Unauthorized globally
      if (error instanceof ApiError && error.status === 401) {
        logger.warn("Global 401 detected (mutation), dispatching unauthorized event");
        window.dispatchEvent(new CustomEvent('unauthorized'));
        return;
      }

      const errorMessage = error instanceof Error ? error.message : "An error occurred";
      logger.error("Global Mutation Error:", error);
      toast.error("Error", { description: errorMessage });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
